module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
  fox.registerWidget(
    "Menu",
    {
      configure: function (options) {
        this.registerOptions("", {
          autoRender: false,
          handleWom: {
            pageChange: {
              widget: "@parent",
              event: "switchedEmbeddedWidget",
              callback: "_switchMenu",
            },
          },
        });

        this.callParent("configure", arguments);
      },

      init: function () {
        this.menus = this.getOption("menus");

        this.callParent("init", arguments);
      },

      rendering: function () {
        this.callParent("rendering", arguments);

        var links = fox.dom.select("[data-link]", this.fragment);
        var currentPage = fox.Navigator.get(0);

        fox.each(
          links,
          function (lnk) {
            var lnk = fox.dom.wrap(lnk);

            if (lnk.attr("data-link") == currentPage) {
              lnk.addClass("active");
            }
          },
          this
        );
      },

      _switchMenu: function (alias) {
        /*if (!this.menus || !this.menus[alias]) {
				this.render();
				return;
			};

			this.currentPage = alias;
			this.renderMenu();*/

        if (!this.menus || !this.menus[alias]) {
          if (this._indom) {
            this.highlightLink(alias);
            return;
          }

          this.render();
          return;
        }

        this.currentPage = alias;
        this.renderMenu();
      },

      renderMenu: function () {
        this.setOption("template", this.menus[this.currentPage]);
        this.render();
      },

      highlightLink: function (alias) {
        var links = fox.dom.select("[data-link]", this.element[0]);

        fox.each(
          links,
          function (lnk) {
            var lnk = fox.dom.wrap(lnk);

            lnk.removeClass("active");
            if (lnk.attr("data-link") == alias) {
              lnk.addClass("active");
            }
          },
          this
        );
      },
    },
    "Widget"
  );
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/menu.js
// module id = 327
// module chunks = 2